module.exports = __webpack_public_path__ + "static/media/icon-ld.08c3bdb7.svg";